'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var getThemeProp = require('../../utils/getThemeProp.js');
require('../../utils/colors.js');
require('../../utils/dates.js');
require('../../utils/numbers.js');
require('../../utils/PrintComponentGenerator/PrintComponentGenerator.js');
require('../../utils/strings.js');
require('../../utils/infiniteScrollCheckStateManager/infiniteScrollCheckStateManager.js');
require('../../utils/pairedTableComponentGenerator/pairedTableComponentGenerator.js');
require('../../utils/safeFetch.js');
require('../../utils/dom.js');

var ListSelectContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  padding: 0.5rem;\n  border-radius: 6px;\n  height: 100%;\n  overflow: auto;\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  .option {\n    cursor: pointer;\n  }\n  .option:hover {\n    background-color: ", ";\n  }\n  .option {\n    &.selected {\n      background-color: lightgray; /* TODO: update with theme color */\n    }\n  }\n"], ["\n  padding: 0.5rem;\n  border-radius: 6px;\n  height: 100%;\n  overflow: auto;\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  .option {\n    cursor: pointer;\n  }\n  .option:hover {\n    background-color: ", ";\n  }\n  .option {\n    &.selected {\n      background-color: lightgray; /* TODO: update with theme color */\n    }\n  }\n"])), getThemeProp('palette.border.main', '#d4dbe4'), getThemeProp('palette.background.default', '#F6F8FC'));
var templateObject_1;

exports.ListSelectContainer = ListSelectContainer;
